import { action } from "satcheljs";
import { IOpenShiftEntity, IShiftRequestEntity } from "sh-models";
const requestOpenShift = action(
    "REQUEST_OPEN_SHIFT",
    (
        openShift: IOpenShiftEntity, onFinish: (shiftRequest: IShiftRequestEntity) => void
    ) => ({
        openShift: openShift, onFinish: onFinish
    })
);

export default requestOpenShift;